import { useTranslation } from "react-i18next";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../Typography/Title";
import { ActionTopBoxStyled } from "../common-styled/ActionTopBoxStyled";
import TaskSelectInput from "components/action-inputs/task/TaskSelectInput";
import ActionTypeInput from "components/action-inputs/action-type/ActionTypeInput";
import OperationInput from "components/action-inputs/operation/OperationInput";
import OtherOperationVariant from "components/action-inputs/other-operation-variant/OtherOperationVariant";

const ActionBaseInfo = ({ viewMode = "view", selectedField }) => {
  const { t } = useTranslation();

  const isViewMode =
    viewMode === ACTION_VIEW_MODE.view || viewMode === ACTION_VIEW_MODE.edit;

  return (
    <ActionTopBoxStyled>
      <Title title={t("ActionModal.ActionType")} />
      <ActionTypeInput isViewMode={isViewMode} />
      <Title title={t("ActionModal.ActionKind")} />
      <TaskSelectInput selectedField={selectedField} isViewMode={isViewMode} />
      <OperationInput isViewMode={isViewMode} />
      <OtherOperationVariant isViewMode={isViewMode} />
    </ActionTopBoxStyled>
  );
};

export default ActionBaseInfo;
